import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { Subject, Subscription } from 'rxjs';
import { PaginationClientSideOptions } from 'src/app/app/_component/pagination-client-side/pagination-client-side-options';
import { PaginationColumn } from 'src/app/app/_component/pagination-client-side/pagination-column.class';
import { SpaceFilterService } from 'src/app/app/_component/_space/space-filter/space-filter.service';
import { HeaderModel } from 'src/app/_component/header/header.model';
import { UserService } from 'src/app/_services';
import { HeaderService } from 'src/app/_services/header.service';
import { ThisPlatform } from 'src/app/_services/platform.service';
import { RowsLoaderService } from 'src/app/_services/rows-loader.service';
import { SpaceType } from 'src/app/_types/space-type';
import { BreadcrumbService } from 'xng-breadcrumb';
import { BookingSection } from '../../../_models/booking.model';
import { SpaceModel } from '../../../_models/space.model';
import { BookingService } from '../../../_services/booking.service';
import { SpaceService } from '../../../_services/space.service';
import { Building } from '../../building/building.model';
import { BuildingService } from '../../building/building.service';
import { SpaceFilter } from '../../_component/_space/space-filter/space-filter.model';
import { BookingViewComponent } from '../booking-view/booking-view.component';
import { RoomFilterModalComponent } from './room-filter-modal/room-filter-modal.component';
import { preventSwipeToClose } from 'src/app/_helpers/preventSwipeToClose';

@Component({
  selector: 'app-room',
  templateUrl: './room.page.html',
  styleUrls: ['./room.page.scss'],
})
export class RoomPage implements OnInit {
  headerInit: HeaderModel = {
    title: 'SPACE.ROOM.CONFERENCE_ROOMS',
    segmentsChangeFunc: ($event) => this.segmentChanged($event),
    activeSegment: this.router.url.includes('my-reservation') ? 'events' : null,
    segments: [
      { name: 'BOOKING.ROOMS_AVAILABLE', value: 'rooms', permissionKeys: [''] },
      {
        name: 'BOOKING.MY_ROOM_RESERVATION',
        value: 'events',
        permissionKeys: [''],
      },
      {
        name: "BOOKING.ROOMS_EDITION",
        value: "edit",
        permissionKeys: ['room.edit'],
      },
    ],
  };

  spaceType = SpaceType.Room;
  componentRefBooking: any = BookingViewComponent;
  rowsLoader: RowsLoaderService;
  roomsFilter: SpaceModel[];
  isSpinner: boolean;
  bookingsRowsLoader: RowsLoaderService;
  bookings: any[];
  bookingsFilter: any[];
  showLoader: boolean;
  valueC = 'rooms'; // odpowiada za widok kalendarza i listy
  showAllReservations: boolean = false;
  segmentsArray = [];
  page: string;
  activeSegment: string;
  spacesChangedSubject = new Subject<any>();
  initBuilding: Building;

  @ViewChild('searchBar')
  searchBar;

  @Output()
  segmentName: EventEmitter<any> = new EventEmitter<any>();

  public bookingServSubscription: Subscription = new Subscription();
  public spaceFilterSubscription: Subscription = new Subscription();

  columnsDefinitionBookings: PaginationColumn[] = [
    {
      name: 'picture',
      displayName: 'IMAGE_PREVIEW',
      size: 2,
      sortable: false,
    },
    {
      name: 'room',
      displayName: 'MENU.ROOM',
      size: 2,
      sortable: true,
      colValue: (row) => {
        return row.bookingSpaces[0].space.name;
      },
    },
    {
      name: 'startTime',
      displayName: 'MENU.DATE',
      size: 2,
      sortable: true,
    },
    {
      name: 'title',
      displayName: 'MENU.TITLE',
      size: 3,
      sortable: true,
    },
    {
      name: 'status',
      displayName: 'MENU.STATUS',
      size: 3,
      sortable: true,
    },
  ];

  options: PaginationClientSideOptions = {
    ...new PaginationClientSideOptions(),
    overrideCountTranslation: 'ADD_INVITATION.INVITATIONS_',
    groupDateKey: 'startTime',
    hideMobileHeader: true,
    noResultsText: 'SPACE.ROOM.NO_RESERVATIONS',
    headerStickyPosition: 121,
    noResultsAddLink: '/app/booking/add-reservation',
    addButtonText: 'SPACE.ADD_RESERVATION',
  };

  constructor(
    public p: ThisPlatform,
    public spaceService: SpaceService,
    private router: Router,
    private bookingServ: BookingService,
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private modalCtrl: ModalController,
    private spaceFilterService: SpaceFilterService,
    private breadcrumbServ: BreadcrumbService,
    private headerServ: HeaderService,
    private buildingServ: BuildingService
  ) {}

  loadRooms() {
    this.showLoader = true;
    this.bookingServ.filterDetailsShowLoader = true;
    this.isSpinner = true;
    this.spaceService
      .getSpaces({ type: SpaceType.Room })
      .subscribe((res: SpaceModel[]) => {
        this.showLoader = false;
        this.bookingServ.filterDetailsShowLoader = false;

        this.spaceService.spaces = res;
        this.roomsFilter = res;
        this.rowsLoaderInit();
        this.isSpinner = false;
        this.bookingServ.equipmentsCounter = res.length;
      });
  }

  async ngOnInit() {
    await this.userService.getPermision();
    this.headerInit.segments.forEach((segment) => {
      if (this.userService.hasRoles(segment.permissionKeys)) {
        this.segmentsArray.push(segment.value);
      }
    });

    this.breadcrumbServ.breadcrumbs$.subscribe(() => {}); // potrzebne aby breadcrumbs się zawsze pojawiało
    
    this.activatedRoute.queryParamMap.subscribe((params) => {
      if (params.get("section")) {
        this.valueC = params.get("section");

        if (this.segmentsArray.filter((el) => el == this.valueC).length > 0) {
          this.activeSegment = this.valueC;
        } else {
          this.activeSegment = this.segmentsArray[0];
          this.setQueryParam(this.segmentsArray[0]);
        }
      } else {
        this.valueC = this.segmentsArray[0];
        this.setQueryParam(this.segmentsArray[0]);
        this.headerServ.setHeaderInit(this.headerInit);
      }
      this.setSegment();
    });
    if (this.router.url.includes('my-reservation')) {
      this.valueC = 'events';
      this.bookingServ.type = BookingSection.MyBookingAll;
      this.bookingServ.reloadBooking();
    }
    this.subscribeEvents();

    this.bookingServSubscription = this.bookingServ.filterDetailsSubject.subscribe(
      () => {
        this.onToggleReservationList();
      }
    );

    this.spaceFilterSubscription = this.spaceFilterService.filterDetailsSubject.subscribe(
      (e) => {
        let params = {
          type: SpaceType.Room,
          buildings:
            e.buildingListId.length > 0 ? e.buildingListId.join(',') : null,
          floors:
            e.floorListId.length > 0 && e.floorListId[0]
              ? e.floorListId.join(',')
              : null,
          capacity: e.capacity,
        };
        this.spaceService.getSpaces(params).subscribe((e: SpaceModel[]) => {
          this.spacesChangedSubject.next(e);
          this.bookingServ.equipmentsCounter = e?.length;
        });
      }
    );

    if(this.buildingServ.buildings.length == 1) {
      this.initBuilding = this.buildingServ.buildings[0];
    }
  }

  ionViewWillEnter() {
    this.headerInit.activeSegment = this.activeSegment;
    this.headerServ.setHeaderInit(this.headerInit);
  }

  rowsLoaderInit() {
    if (this.rowsLoader) {
      this.rowsLoader.init(this.roomsFilter);
    }
  }

  bookingRowsLoaderServiceReady(loader: RowsLoaderService) {
    this.bookingsRowsLoader = loader;
  }

  onReroute() {
    this.router.navigate(['/app/booking/add-reservation']);
  }

  bookingRowsLoaderInit() {
    if (this.bookingsRowsLoader) {
      this.showLoader = false;
      this.bookingServ.filterDetailsShowLoader = false;

      if (this.searchBar.ngModel && this.searchBar.ngModel.length > 0) {
        this.bookingsFilter = this.bookings.filter((s) =>
          (s.description + ' ' + s.title)
            .toUpperCase()
            .includes(this.searchBar.ngModel.toUpperCase())
        );
      } else {
        this.bookingsFilter = this.bookings;
      }

      this.bookingsRowsLoader.init(this.bookingsFilter);
    }
  }

  refreshBookings(bookings: any) {
    this.bookings = bookings;
    this.bookingRowsLoaderInit();
    this.bookingServ.bookingsCounter = bookings.length;
  }

  subscribeEvents() {
    this.bookingServSubscription.add(
      this.bookingServ.bookingsSubject.subscribe((p) => {
        this.refreshBookings(p);
        this.showLoader = false;
        this.bookingServ.filterDetailsShowLoader = false;
      })
    );
  }

  segmentChanged($event) {
    this.valueC = $event.detail.value;
    this.setQueryParam($event.detail.value);
    this.spaceFilterService.filterDetails = new SpaceFilter();
  }

  setSegment() {
    if (this.valueC === 'events') {
      this.showLoader = true;
      this.bookingServ.filterDetailsShowLoader = true;

      if (this.showAllReservations) {
        this.bookingServ.type = BookingSection.MyBookingAll;
      } else {
        this.bookingServ.type = BookingSection.MyBookingFuture;
      }
      this.bookingServ.reloadBooking();
    } else if (this.valueC === 'rooms') {
      this.loadRooms();
    }
  }

  setQueryParam(value) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { section: value },
      queryParamsHandling: 'merge', // remove to replace all query params by provided
    });
  }

  onChangeSearch(data) {
    this.rowsLoaderInit();
  }

  onToggleReservationList() {
    this.showLoader = true;
    this.bookingServ.filterDetailsShowLoader = true;

    this.showAllReservations = !this.showAllReservations;
    if (this.showAllReservations) {
      this.bookingServ.type = BookingSection.MyBookingAll;
    } else {
      this.bookingServ.type = BookingSection.MyBookingFuture;
    }
    this.bookingServ.reloadBooking();
    this.bookingServ.booking;
    this.subscribeEvents();
  }

  async onToggleFilter() {
    const modal = await this.modalCtrl.create({
      component: RoomFilterModalComponent,
      componentProps: {
        page: 'reservation-list',
        initialBuilding: this.initBuilding
      },
      canDismiss: preventSwipeToClose,
      cssClass: 'add-edit-modal mobile-filter__modal-container',
    });
    modal.present();
  }

  roomSelected(value) {
    this.router.navigateByUrl('app/booking/' + value);
  }

  rowsLoaderServiceReady(loader: RowsLoaderService) {
    this.rowsLoader = loader;
  }

  ngOnDestroy() {
    this.bookingServSubscription.unsubscribe();
    this.spaceFilterSubscription.unsubscribe();
    this.spaceFilterService.filterDetails = new SpaceFilter();
    this.bookingServ.startTime = null;
    this.bookingServ.endTime = null;
  }
}
